export const LogoMark = ({ className = "w-9 h-9", ...props }) => (
  <img src="/logo.png" alt="Crusaders of the Cross emblem" className={`object-contain ${className}`} {...props} />
);

export const LogoFull = ({ className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <LogoMark className="w-10 h-10 transition-transform duration-500 hover:scale-110" />
    <div className="leading-none">
      <div className="font-display font-bold text-sm tracking-[0.14em] text-parchment uppercase">Crusaders</div>
      <div className="font-mono text-[10px] tracking-[0.32em] text-gold uppercase mt-1">of the Cross</div>
    </div>
  </div>
);
